import { useContext } from 'react';
import { Formik } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { ToolEditForm } from './components';
import { toolSchema, toolEditContext } from './ToolEditContext';

let ToolEdit = () => {
    let service = useContext(toolEditContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.tool}
                validationSchema={toolSchema}
                onSubmit={(values, action) => {
                    service.saveTool(values);
                    action.setSubmitting(false);;
                }}
            >
                <>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false && <ToolEditForm />}
                </>
            </Formik>
        </Container>
    )
}

export default ToolEdit;